import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { cleanStockPublicationSettings } from "../../api/thunks/cleanStockPublicationSettings";
import { cloneSettings } from "../../lib/cloneSettings";
import { StockPublicationSliceState } from "../../types";

export const addCleanSettingsExtraReducers = (
  builder: ActionReducerMapBuilder<StockPublicationSliceState>,
) => {
  builder
    .addCase(cleanStockPublicationSettings.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    })
    .addCase(cleanStockPublicationSettings.fulfilled, (state, action) => {
      state.isLoading = false;
      state.dictionaries = action.payload.dictionaries;
      state.savedSettings = action.payload.settings;
      state.draftSettings = cloneSettings(action.payload.settings);
    })
    .addCase(cleanStockPublicationSettings.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload ?? "Ошибка сброса настроек";
    });
};
